export interface PaysafeShippingAddress {
  city?: string;
  country: string;
  recipientName?: string;
  state?: string;
  street?: string;
  street2?: string;
  zip: string;
}
